import template from './sw-cms-block-image-three-cover.html.twig';
import './sw-cms-block-image-three-cover.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
